export const PROFILE_INFORMATION = {
    BASIC_INFORMATION: 1,
    ACADEMIC_QUALIFICATIONS: 2,
    WORKING_EXPERIENCE: 3,
    CV: 4,
};

export const PROFILE_INFORMATION_TABS = [
    {
        name: "Basic Information",
        type: PROFILE_INFORMATION.BASIC_INFORMATION,
    },
    {
        name: "Academic Qualifications",
        type: PROFILE_INFORMATION.ACADEMIC_QUALIFICATIONS,
    },
    {
        name: "Working Experience",
        type: PROFILE_INFORMATION.WORKING_EXPERIENCE,
    },
    {
        name: "CV",
        type: PROFILE_INFORMATION.CV,
    },
];

export const ENDORSEMENT_STATUS = {
    REJECTED: 1,
    APPROVED: 2,
    PENDING: 3,
};

export const ENDORSEMENT_STATUS_OBJECT = {
    1: "REJECTED",
    2: "APPROVED",
    3: "PENDING",
};

export const notificationPaths = {
    1: (notification) => `/dashboard/endorsement/${JSON.parse(notification.payload)?.userId}`,
    4: "/atp/cpdactivities/",
    5: "/certifications",
    6: "/cpd-activities/my-activities",
    11: "/dashboard"
    // 7: "/dashboard"
};
